import { type SearchDocumentParams } from "@prismicio/editor-fields"

const filterTypes = ["customTypes", "tags", "authors"] as const

/**
 * Updates the filter params based on the new search params
 * @param newSearchDocumentParams
 * @param currentDocumentParams
 * @returns serialized filter params ready to be used in the url
 */
export function updateFilterParams(
  newSearchDocumentParams: SearchDocumentParams,
  currentDocumentParams: SearchDocumentParams
): SearchDocumentParams {
  const filterParams: SearchDocumentParams = {}

  for (const filterType of filterTypes) {
    const newFilter = newSearchDocumentParams[filterType]
    const currentFilter = currentDocumentParams[filterType]

    if (newFilter) {
      filterParams[filterType] = newFilter.length ? [newFilter.toString()] : []
    } else if (currentFilter && currentFilter.length > 0) {
      filterParams[filterType] = [currentFilter.toString()]
    }
  }

  return filterParams
}
